"use strict";
/**
 * @author by Gor.Hakobyan on 08-May-18.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var DataFormat = /** @class */ (function () {
    function DataFormat(type, isPercentage, numberOfDecimalPlaces, isMultiline, isComment, isMultilingual) {
        if (isPercentage === void 0) { isPercentage = false; }
        if (numberOfDecimalPlaces === void 0) { numberOfDecimalPlaces = 1; }
        if (isMultiline === void 0) { isMultiline = false; }
        if (isComment === void 0) { isComment = false; }
        if (isMultilingual === void 0) { isMultilingual = false; }
        this.type = type;
        this.isPercentage = isPercentage;
        this.numberOfDecimalPlaces = numberOfDecimalPlaces;
        this.isMultiline = isMultiline;
        this.isComment = isComment;
        this.isMultilingual = isMultilingual;
    }
    DataFormat.prototype.clone = function () {
        return new DataFormat(this.type, this.isPercentage, this.numberOfDecimalPlaces, this.isMultiline, this.isComment, this.isMultilingual);
    };
    return DataFormat;
}());
exports.DataFormat = DataFormat;
//# sourceMappingURL=data-format.model.js.map